import Vue from 'vue'
import ProcessFlowStepJumpTo from '~/models/processFlows/processFlowStepJumpTo'
import ProcessFlowStepAction from '~/models/processFlows/processFlowStepAction'
import Guid from '~/helpers/guid'
import ProcessFlowStepElementConditionalRuleSet from '~/models/processFlows/processFlowStepElementConditionalRuleSet'

export default class ProcessFlowStepActionJumpToFactory {
  static create(parent: ProcessFlowStepAction | ProcessFlowStepElementConditionalRuleSet): ProcessFlowStepJumpTo {
    return ProcessFlowStepActionJumpToFactory.createFor(parent,
      parent instanceof ProcessFlowStepAction ? 'jump_to' : 'conditional_value');
  }

  private static createFor(parent: ProcessFlowStepAction | ProcessFlowStepElementConditionalRuleSet, fieldName: string) {
    const processFlowStepJumpTo: ProcessFlowStepJumpTo = new ProcessFlowStepJumpTo();

    processFlowStepJumpTo.defineProperty<ProcessFlowStepJumpTo>('client_id', Guid.create());
    processFlowStepJumpTo.defineProperty<ProcessFlowStepJumpTo>('to_client_id', '');

    processFlowStepJumpTo.parent = parent;
    Vue.set(parent, fieldName, processFlowStepJumpTo);

    return processFlowStepJumpTo;
  }
}